const isBoolean = require('lodash/isBoolean');
const isFunction = require('lodash/isFunction');
const get = require('lodash/get');

module.exports = class SpinnerOverlayController {
  constructor() {
    this.visible = false;
  }

  $onChanges(changes) {
    const expression = changes.expression.currentValue;

    if (isBoolean(expression)) {
      this.visible = expression;
    }
    else if (isFunction(get(expression, 'then'))) {
      this.visible = true;

      expression.finally(() => {
        this.visible = false;
      });
    }
    else {
      this.visible = false;
    }
  }
};
